import React, { useEffect, useState } from 'react';

import UserPermissions from '../Service/UsersPermission';
import Swal from 'sweetalert2';

const PERMISSIONS = window.AppConfig.PERMISSIONS;

export default function useFetchCurrentPermissions() {
	const [state, setState] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let isApiSubscribed = true;

		setLoading(true);

		UserPermissions.getCurrentPermissions()
			.then(res => {
				if (isApiSubscribed) {
					setState(res);
					setLoading(false);
				}
			})
			.catch(error => {
				toastWhenFail(`Error: ${error.message}`);
				setLoading(false);
			});

		return () => (isApiSubscribed = false);
	}, []);

	const toastWhenFail = resp => {
		Swal.fire({
			allowOutsideClick: false,
			title: 'Something went wrong!',
			text: resp,
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			customClass: 'otp_message_success'
		});
	};

	const ACCESS_TO_BACKEND_USER_MANAGEMENT = state?.find(
		m => m.permissions === PERMISSIONS.ACCESS_TO_BACKEND_USER_MANAGEMENT
	);

	const ACCESS_TO_LIST_OF_USERS = state?.find(m => m.permissions === PERMISSIONS.ACCESS_TO_LIST_OF_USERS);

	const ACCESS_TO_THE_DASHBOARD = state?.find(m => m.permissions === PERMISSIONS.ACCESS_TO_THE_DASHBOARD);

	const ACCESS_TO_THE_TRANSACTION = state?.find(m => m.permissions === PERMISSIONS.ACCESS_TO_THE_TRANSACTION);

	return {
		loading,
		ACCESS_TO_BACKEND_USER_MANAGEMENT,
		ACCESS_TO_LIST_OF_USERS,
		ACCESS_TO_THE_DASHBOARD,
		ACCESS_TO_THE_TRANSACTION
	};
}
